import WorkLocations from './WorkLocations/WorkLocations';
import PrincipalCompanyInfo from './PrincipalCompanyInfo/PrincipalCompanyInfo';

const EmploymentInformation = () => {
  return (
    <div className="flex flex-col gap-[8px]">
      <PrincipalCompanyInfo />
      <WorkLocations />
    </div>
  );
};

export default EmploymentInformation;
